import type { SearchDropdownItem } from '@/components/ui/search-dropdown'
import type {
  BuildiumStaffUser,
  BuildiumVendor,
  BuildiumTaskCategory,
} from '@super/shared-types'

export const mapStaffUserToItem = (
  user: BuildiumStaffUser,
): SearchDropdownItem<number> | null => {
  const label = `${user.FirstName ?? ''} ${user.LastName ?? ''}`.trim()
  if (!label) return null
  return {
    id: String(user.Id),
    label,
    sublabel: user.Email ?? undefined,
    data: user.Id,
  }
}

export const mapVendorToItem = (
  vendor: BuildiumVendor,
): SearchDropdownItem<number> | null => {
  const label = vendor.IsCompany
    ? vendor.CompanyName
    : `${vendor.FirstName ?? ''} ${vendor.LastName ?? ''}`.trim()
  if (!label) return null
  return {
    id: String(vendor.Id),
    label,
    sublabel: vendor.PrimaryEmail ?? undefined,
    data: vendor.Id,
  }
}

export const mapTaskCategoryToItem = (
  category: BuildiumTaskCategory,
): SearchDropdownItem<number> | null => {
  if (!category.Name) return null
  return {
    id: String(category.Id),
    label: category.Name,
    data: category.Id,
  }
}
